import VariantAnnotationsBarChart from 'pages/VariantAnnotations/chart';

export default function VariantAnnotationsSection() {
  return (
    <div id="section-va">
      <h3>Variant Annotations</h3>
      <VariantAnnotationsBarChart />
    </div>
  );
}
